import z from "zod";

export const UnitTypeEnum = z.enum(["duplex", "triplex"]);
export type UnitType = z.infer<typeof UnitTypeEnum>;
export const UnitTypeValues = UnitTypeEnum.options as [UnitType, ...UnitType[]];

export const BedRoomSchema = z.number().min(0).max(20);
export const LivingRoomSchema = z.number().min(0).max(10);
export const BathroomSchema = z.number().min(1).max(10);

export const PlanValues = {
  unitType: UnitTypeValues,
};
